import React from 'react';
import { Box, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { PASSWORD_RULES } from '../../utils/passwordPolicy';

/**
 * Real-time password requirement checklist.
 * Renders only when the user has started typing (password.length > 0).
 */
export default function PasswordRequirements({ password = '' }) {
  if (!password) return null;
  return (
    <Box sx={{
      mt: 1, p: 1.5, borderRadius: '8px',
      background: 'rgba(79,70,229,0.04)',
      border: '1px solid rgba(79,70,229,0.12)',
    }}>
      <Typography sx={{
        fontSize: '0.6875rem', fontWeight: 700, color: 'text.secondary',
        mb: 0.75, textTransform: 'uppercase', letterSpacing: '0.07em',
      }}>
        Password requirements
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.4 }}>
        {PASSWORD_RULES.map(rule => {
          const met = rule.test(password);
          return (
            <Box key={rule.key} sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
              {met
                ? <CheckCircleOutlineIcon  sx={{ fontSize: 14, color: '#15803D', flexShrink: 0 }} />
                : <RadioButtonUncheckedIcon sx={{ fontSize: 14, color: 'text.disabled', flexShrink: 0 }} />}
              <Typography sx={{ fontSize: '0.75rem', color: met ? '#15803D' : 'text.secondary', lineHeight: 1.4 }}>
                {rule.label}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
